// Shared read contract for client rows that also contain private backend fields.
export const CLIENT_BROWSER_FIELDS = 'client_id,assistant_name,whatsapp_number';
